export default __webpack_public_path__ + "static/media/errorpage.a957e749.svg";